import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcTextFieldComponent} from './ac-text-field.component';
import {MatInputModule} from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule
    ],
    declarations: [
        AcTextFieldComponent,
    ],
    entryComponents: [
        AcTextFieldComponent,
    ],
    exports: [
        AcTextFieldComponent,
    ]
})
export class AcTextFieldModule {
}
